import React from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import { st, classes } from './StepsListAsTiles.st.css';
import { StepSidebar } from './StepSidebar';
import { ScheduledStepsList } from './ScheduledStepsList';
import { FCWithChildren } from '@wix/challenges-web-library';
import { ParticipantStep } from '../../../../../types/v3Types';
import { useCSSPBEnabled } from '../../../../../hooks/useCSSPBStyle';

export interface IStepsListAsTilesProps {
  dataHook?: string;
  steps: ParticipantStep[];
  isSPC: boolean;
  currentStepId: string;
  onStepChosen(step: ParticipantStep): void;
  isSectionLocked?: boolean;
}

export const StepsListAsTiles: FCWithChildren<IStepsListAsTilesProps> = (
  props,
) => {
  const { steps = [], isSPC, isSectionLocked = false } = props;
  const { isMobile, isRTL } = useEnvironment();
  const cssPBEnabled = useCSSPBEnabled({
    includeParticipantPageAlignmentCheck: true,
  });

  return (
    <div
      className={st(classes.root, {
        mobile: isMobile,
        withCSSAlignment: cssPBEnabled,
        rtl: isRTL,
      })}
      data-hook={props.dataHook || null}
      dir="auto"
    >
      {isSPC ? (
        <ul className={classes.stepsList}>
          {steps.map((step, ind) => {
            return (
              <StepSidebar
                key={ind}
                step={step}
                isSPC={props.isSPC}
                currentStepId={props.currentStepId}
                onStepChosen={props.onStepChosen}
                isSectionLocked={isSectionLocked}
              />
            );
          })}
        </ul>
      ) : (
        <ScheduledStepsList
          steps={steps}
          isSPC={props.isSPC}
          currentStepId={props.currentStepId}
          onStepChosen={props.onStepChosen}
        />
      )}
    </div>
  );
};

StepsListAsTiles.displayName = 'StepsListAsTiles';
